import React from 'react'
import { useTranslation } from 'react-i18next'

export const AdminProducts = () => {
  const { t } = useTranslation()
  return <>{t('admin.products')}</>
}